/**
 * The soft-tissue springs a loaded file DECLARED (ADR-038 J2), with the region
 * surface each carries in `extras.poqpoq.jiggle`, remembered against the scene
 * the loader returned — the {@link declaredSprings} side table's sibling.
 *
 * WHY A SECOND TABLE. The tail's Body-tab control adopts the FIRST declared
 * spring of a file as its tail; a file whose only springs are jiggle leaves
 * would hand it a breast. The load door therefore files `jiggle-*` springs
 * here and every other spring in `declaredSprings`, so each control sees only
 * its own. `loadGLB().springs` still lists them all, in file order.
 *
 * Depends on: kernel (types). Depended on by: load-glb (writes), the app's
 * jiggle control (reads).
 */
import type { Object3D } from 'three';
import type { SoftTissueExtras, SpringDeclaration } from '@harryhausen/kernel';

export interface DeclaredSoftTissueSpring {
  readonly decl: SpringDeclaration;
  /** The region surface the file recorded, or null when a reader wrote the spring without it. */
  readonly extras: SoftTissueExtras | null;
}

const declared = new WeakMap<Object3D, readonly DeclaredSoftTissueSpring[]>();

export function rememberDeclaredSoftTissue(scene: Object3D, springs: readonly DeclaredSoftTissueSpring[]): void {
  declared.set(scene, springs);
}

/** The soft-tissue springs the file behind `scene` declared; empty when none. */
export function declaredSoftTissue(scene: Object3D): readonly DeclaredSoftTissueSpring[] {
  return declared.get(scene) ?? [];
}
